import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js'
// import { Formik, Field, ErrorMessage } from 'formik';
import Axios from 'axios';
import { Spinner, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { API_BASE_URL } from './config';
import currentVersion from '../version.json';
import Logo from './../img/logoPortal.png';
import PlanoDeFundo from './../img/paginaLogin.png'

const LoginTela = () => {
    const [loginError, setLoginError] = useState(false);
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const clearBrowserCaches = async () => {
        if (!('caches' in window)) return;
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
    };

    const fetchLatestFrontendVersion = async () => {
        const response = await fetch(`/version.json?t=${new Date().getTime()}`, {
            cache: 'no-store',
            headers: {
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
        });

        if (!response.ok) return null;
        return await response.json();
    };

    const maybeRefreshBeforeEnter = async (destination) => {
        try {
            const latestVersion = await fetchLatestFrontendVersion();
            const latest = latestVersion && latestVersion.version ? String(latestVersion.version) : null;
            const local = currentVersion && currentVersion.version ? String(currentVersion.version) : null;

            if (!latest || !local || latest === local) {
                return { action: 'continue' };
            }

            return await new Promise((resolve) => {
                const toastId = 'login-version-update-toast';

                const continueNow = () => {
                    toast.dismiss(toastId);
                    resolve({ action: 'continue' });
                };

                const updateNow = () => {
                    localStorage.setItem('postLoginRedirect', destination);
                    toast.dismiss(toastId);
                    resolve({ action: 'reload' });
                };

                const timer = setTimeout(() => {
                    resolve({ action: 'continue' });
                    toast.dismiss(toastId);
                }, 5000);

                toast.info(
                    <div className="d-flex flex-column gap-2">
                        <span>Nova versão disponível. Atualizar antes de entrar?</span>
                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-sm btn-light text-primary fw-bold"
                                onClick={() => {
                                    clearTimeout(timer);
                                    updateNow();
                                }}
                            >
                                Atualizar e entrar
                            </button>
                            <button
                                className="btn btn-sm btn-outline-light text-white fw-bold"
                                onClick={() => {
                                    clearTimeout(timer);
                                    continueNow();
                                }}
                            >
                                Continuar
                            </button>
                        </div>
                        <small className="opacity-75">Continuando automaticamente em 5s…</small>
                    </div>,
                    {
                        toastId,
                        position: "bottom-right",
                        autoClose: false,
                        closeOnClick: false,
                        draggable: false,
                        closeButton: false,
                        onClose: () => clearTimeout(timer)
                    }
                );
            });
        } catch (e) {
            return { action: 'continue' };
        }
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setIsLoggingIn(true);
            handleClickLogin({ login, password });
        }
    };


    const handleClickLogin = async (values) => {
        try {
            const response = await Axios.post(`${API_BASE_URL}/login`, values);
            console.log('Resposta recebida:', response.data);
            setIsLoggingIn(true);

            if (response.data.msg === 'Usuário Logado com sucesso') {
                // console.log('Entrou no if: Usuário Logado com sucesso');
                // Armazenar o tipo de usuário após o login bem-sucedido
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('userType', response.data.userType);
                localStorage.setItem('userName', response.data.userName);
                localStorage.setItem('userId', response.data.userId);
                localStorage.setItem('userProfilePhoto', response.data.userProfilePhoto);
                localStorage.setItem('schoolId', response.data.schoolId);
                localStorage.setItem('turmaID', response.data.turmaID);

                const destination = response.data.userType === 5 ? '/home/' : '/home';
                const refreshDecision = await maybeRefreshBeforeEnter(destination);
                if (refreshDecision.action === 'reload') {
                    await clearBrowserCaches();
                    window.location.reload();
                    return;
                }

                if (response.data.userType === 5) {
                    navigate('/home/');
                } else {
                    navigate('/home');
                }
            } else if (response.data.msg == 'Usuário ou senha incorretos') {
                // console.log('Entrou no else if: Usuário ou senha incorretos');
                toast.error(response.data.msg);
                setLoginError(true);
            } else {
                console.log('Entrou no else: Nenhum dos ifs foi atendido');
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro de resposta do servidor:', error.response.data);
                console.error('Status do erro:', error.response.status);
                console.error('Cabeçalhos do erro:', error.response.headers);
            } else if (error.request) {
                console.error('Erro na requisição:', error.request);
            } else {
                console.error('Erro ao processar a requisição:', error.message);
            }
            // console.log('Entrou no catch');
            setIsLoggingIn(false);
            toast.error('Erro ao fazer login.');
        } finally {
            // console.log('Entrou no finally');
            // toast.error("Usuário ou senha incorretos");
            setIsLoggingIn(false);
        }
    };


    useEffect(() => {
        const timer = setTimeout(() => setIsPageLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const destination = localStorage.getItem('postLoginRedirect');
        const token = localStorage.getItem('token');
        if (token && destination) {
            localStorage.removeItem('postLoginRedirect');
            navigate(destination);
        }
    }, [navigate]);

    useEffect(() => {
        const root = document.documentElement;
        const previousTheme = root.getAttribute('data-theme');
        root.setAttribute('data-theme', 'light');

        return () => {
            if (previousTheme) {
                root.setAttribute('data-theme', previousTheme);
            } else {
                root.removeAttribute('data-theme');
            }
        };
    }, []);

    // Tela de carregamento inicial
    if (isPageLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner animation="border" variant="primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </Spinner>
            </div>
        );
    }

    return (

        <>
            <ToastContainer />
            <section className="auth bg-base d-flex flex-wrap">
                <style>{`
                    @media (max-width: 1446px) {
                        .auth-left {
                            display: none !important;
                        }
                        .auth {
                            background-color: #f8f9fa !important;
                            justify-content: center !important;
                            align-items: center !important;
                        }
                        .auth-right {
                            width: 100% !important;
                            max-width: 100% !important;
                            display: flex !important;
                            justify-content: center !important;
                            align-items: center !important;
                            min-height: 100vh !important;
                        }
                    }
                    .login-logo-mobile {
                        display: none;
                    }
                    @media (max-width: 1446px) {
                        .login-logo-mobile {
                            display: block;
                            margin-bottom: 40px;
                            text-align: center;
                        }
                        .login-logo-mobile img {
                            width: 50%;
                            height: auto;
                            display: inline-block;
                            border-radius: 10px;
                        }
                    }
                `}</style>
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 w-auto justify-content-center">
                        <img src={PlanoDeFundo} alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "left"
                            }} />
                    </div>
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100">
                        <div>
                            <Link to="/" className="max-w-390-px login-logo-mobile">
                                <img src={Logo} alt="" />
                            </Link>
                            <h4 className="mb-12">Entre com sua conta</h4>
                            <p className="mb-32 text-secondary-light text-lg">
                                Bem-vindo de volta! Por favor, insira seus dados
                            </p>
                        </div>
                        <form action="#">
                            <div className="icon-field mb-16">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="mdi:account" />
                                </span>
                                <input
                                    type="text"
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="Login"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                />
                            </div>
                            <div className="position-relative mb-20">
                                <div className="icon-field">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="solar:lock-password-outline" />
                                    </span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        id="your-password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                                {/* <span
                                    className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <Icon icon={showPassword ? 'mdi:eye-off' : 'mdi:eye'} />
                                </span> */}
                            </div>
                            <div className="">
                                {/* <div className="d-flex justify-content-between gap-2">
                                    <div className="form-check style-check d-flex align-items-center">
                                        <input
                                            className="form-check-input border border-neutral-300"
                                            type="checkbox"
                                            defaultValue=""
                                            id="remeber"
                                            onChange={(e) => setRememberMe(e.target.checked)}
                                        />

                                        <label className="form-check-label" htmlFor="remeber">
                                            Lembre de mim{" "}
                                        </label>
                                    </div>
                                    <Link to="#" className="text-primary-600 fw-medium">
                                        Esqueceu sua senha?
                                    </Link>
                                </div> */}
                            </div>
                            {/* <button
                                type="button"
                                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                onClick={() => handleClickLogin({ login, password })}
                            >
                                {" "}
                                Entrar
                                </button> */}

                            <button
                                type="button"
                                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                onClick={() => {
                                    setIsLoggingIn(true);
                                    handleClickLogin({ login, password });
                                }}
                                disabled={isLoggingIn}
                            >
                                {" "}
                                {isLoggingIn ? <Spinner animation="border" size="sm" /> : "Entrar"}
                            </button>

                            {/* <div className="mt-32 center-border-horizontal text-center">
                            <span className="bg-base z-1 px-4">Ou faça login com</span>
                        </div> */}
                            {/* <div className="mt-32 d-flex align-items-center gap-3">
                            <button
                                type="button"
                                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                            >
                                <Icon
                                    icon="ic:baseline-facebook"
                                    className="text-primary-600 text-xl line-height-1"
                                />
                                Google
                            </button>
                            <button
                                type="button"
                                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                            >
                                <Icon
                                    icon="logos:google-icon"
                                    className="text-primary-600 text-xl line-height-1"
                                />
                                Google
                            </button>
                        </div> */}
                            {/* <div className="mt-32 text-center text-sm">
                            <p className="mb-0">
                                Não tem uma conta?{" "}
                                <Link to="/sign-up" className="text-primary-600 fw-semibold">
                                    Inscrever-se
                                </Link>
                            </p>
                        </div> */}
                        </form>
                    </div>
                </div>
            </section>
        </>

    )
}

export default LoginTela
